#import "../NoteFields.graphql"

mutation updateUsDueDiligenceNote($id: ID!, $content: String!) {
  updateUsDueDiligenceNote(input: { id: $id, content: $content }) {
    usDueDiligenceNote {
      ...NoteFields
    }
  }
}
